import { handleActions } from 'redux-actions';
import immutable from 'object-path-immutable';
import * as actions from './actions';

const defaultState = {
  currentUser: null,
  currentUserInfo: null,
  authChecking: true,
  authCheckError: null,
  isSessionLoaded: false,
};

const authUserReducer = handleActions(
  new Map([
    [actions.sessionLoadRequest,
      (state, action) => {
        return Object.assign({}, state, {
          authChecking: true,
          authCheckError: null
        });
      }],
    [actions.sessionLoadSuccess,
      (state, action) => {
        return Object.assign({}, state, {
          authChecking: false,
          authCheckError: null,
          currentUser: action.payload.user,
          currentUserInfo: action.payload.info,
          isSessionLoaded: true
        });
      }],
    [actions.sessionLoadFailed,
      (state, action) => {
        return Object.assign({}, state, {
          authChecking: false,
          authCheckError: action.payload,
          currentUser: null,
          currentUserInfo: null,
          isSessionLoaded: true
        });
      }],

    [actions.setCurrentUserInfo,
      (state, action) => {
        return immutable.set(state, 'currentUserInfo', action.payload);
      }],

  ]),
  defaultState
);

export default authUserReducer;


// WEBPACK FOOTER //
// ./src/app/modules/auth/store/auth-user/reducer.ts